
import { DollarSign, ShoppingCart } from "lucide-react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/Card";
import { formatPrice } from "@/utils/format";
import { Product } from "@/prisma-types";

function ProductStatsPannel({ product }: { product: Product }) {
  // Calculate sales statistics
  const totalSales =
    product.orderItems?.reduce((sum, item) => sum + item.quantity, 0) || 0;
  const totalRevenue =
    product.orderItems?.reduce(
      (sum, item) => sum + item.quantity * Number(item.price),
      0
    ) || 0;
  const averagePrice =
    totalSales > 0 ? Math.round((totalRevenue / totalSales) * 100) / 100 : 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <Card className="">
        <CardHeader className="pb-2">
          <CardTitle className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
            <ShoppingCart className="w-4 h-4" />
            Total Vânzări
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-foreground">
            {totalSales} bucăți
          </div>
        </CardContent>
      </Card>
      <Card className="">
        <CardHeader className="pb-2">
          <CardTitle className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
            <DollarSign className="w-4 h-4" />
            Venit Total
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-foreground">
            {formatPrice(totalRevenue)}
          </div>
        </CardContent>
      </Card>
      <Card className="">
        <CardHeader className="pb-2">
          <CardTitle className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
            <DollarSign className="w-4 h-4" />
            Preț Mediu
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-foreground">
            {formatPrice(averagePrice)}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default ProductStatsPannel;
